////////LIBRARY/////////
import { isUndefined } from 'lodash'
///////COMPONENTS///////
import { put, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { errorManagerActionCreators, globalLoadingActionCreators, modalsActionCreators } from '../actions'

const createError = function* ({ payload }) {
	const error = payload.error
	const redirectPath = payload.redirectPath
	let modal
	const modalTitle = {
		title: 'modal__validationFailed',
	}
	yield put(globalLoadingActionCreators.endLoading())
	if (!isUndefined(error)) {
		if (!isUndefined(error.status)) {
			switch (error.status) {
				/* case 500:
					modal = {
						level: 'error',
						title: 'modal__errorDefault__title',
						key: 'modal__errorDefault__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break */

				case 503:
					yield put(errorManagerActionCreators.modeMaintenance('/maintenance'))
					break

				case 404:
					modal = {
						level: 'error',
						title: 'modal__error404__title',
						key: 'modal__error404__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break

				case 200:
					modal = {
						level: 'error',
						title: 'modal__error200PartialSuccess__title',
						key: 'modal__error200PartialSuccess__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break

				case 400:
					modal = {
						level: 'error',
						title:
							error.data.traductionKey === 'common__message__company_labelCommercial_alreadyExist'
								? modalTitle.title
								: 'modal__error400__title',
						key: error.data.traductionKey,
						errorMsgParams: error.data.msgParameters,
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}
					yield put(modalsActionCreators.hydrateModal(modal))
					break

				case 401:
					modal = {
						level: 'error',
						title: 'modal__error401__title',
						key: error.data.traductionKey,
						errorMsgParams: error.data.msgParameters,
						show: true,
						// Is not necessarily an expired token or unauthorized connection,
						// So we cannot force to login in this case
						path: redirectPath !== '' ? redirectPath : '',
						insideModalResponse: true,
					}
					yield put(modalsActionCreators.hydrateModal(modal))
					break

				default:
					modal = {
						level: 'error',
						title: 'modal__errorDefault__title',
						key: 'modal__errorDefault__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break
			}
		} else {
			modal = {
				level: 'error',
				title: 'modal__errorDefault__title',
				key: 'modal__errorDefault__body',
				show: true,
				path: redirectPath,
				insideModalResponse: true,
			}
			yield put(modalsActionCreators.hydrateModal(modal))
		}
	} else {
		modal = {
			level: 'error',
			title: 'modal__errorDefault__title',
			key: 'modal__errorDefault__body',
			show: true,
			path: redirectPath,
			insideModalResponse: true,
		}
		yield put(modalsActionCreators.hydrateModal(modal))
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.CREATE_ERROR, createError)
}

export default sagas
